import Page from '../../layout/Page'
import FourOhFourPageContent from './FourOhFourPageContent'

const FourOhFourPage = () => (
  <Page menu={<div />} content={<FourOhFourPageContent />} />
)

export default FourOhFourPage
